import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table } from 'react-bootstrap';
import Moment from 'react-moment';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import SvgIcon from 'react-icons-kit';
import Loader from 'react-loader-spinner';
import swal from 'sweetalert';
var Config = require('../../config');

class ModalHistorico extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.getHistory = this.getHistory.bind(this);
		this.state = {
		    show: false,
		    donor_id:"",
		    history:[],
			opening:false,
			functional_criterial:{}
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donor_id, functional_criterial) {
		this.setState({ show: true,donor_id:donor_id, functional_criterial:functional_criterial });
		this.getHistory(donor_id);
	}

	getHistory(donor_id){
		fetch(Config.default.apiGateway.URL+'clinic_history?option='+donor_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
			if(res.ok){
				return res.json();
			}console.log(res)})
		.then(response => {
			this.setState({history:response});
		})
	}

	getStatus(key){
		var res = "";

		switch(key){
			case 'ACCEPT':res = "ACEPTADO"; break;
			case 'REJECT':res = "RECHAZADO"; break;
			case 'DIFERIDO':res = "DIFERIDO"; break;
			case 'PENDING':res = "PENDIENTE"; break;
			default:
				res = "";
			break
		}

		return res;
	}

	openPDF(id){
		this.setState({opening:true});
		var url = "clinic_history?clinic_history_id="+id+"&health_facility="+sessionStorage.getItem("health_facilities_id")
			fetch(Config.default.apiGateway.URL+url, {
				method : 'post',
				responseType: 'blob', //Force to receive data in a Blob Format
				headers : new Headers({
					'Authorization': 'Bearer '+sessionStorage.getItem('token'),
					'Content-Type': 'application/pdf'
				})
			})
			.then(res => {
				this.setState({opening:false});
		          if(res.ok){
		            return res.blob();
		          }else{
		            res.text().then(function(error) {
		              swal('¡Error!', "No ha sido posible imprimir", 'error');
		            });
		        }
		    })
			.then(response => {
				if(response !== undefined){
					//if(this.state.functional_criterial.value === "NO"){
						var fileURL = URL.createObjectURL(response);
					   window.open(fileURL);
					/*}else{
						this.props.directPrint(response);
					}*/
	       		}
			})
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_history.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        {this.state.opening?
		        	<div style={{textAlign:'center'}}>
						<Loader 
							type="Oval" 
							color="#64b5f6" 
							height={80} 
							width={80}
							/> 
					</div>:
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <Table responsive hover>
				          <thead>
				            <tr>
				              <th>{t('content.modal_history.medical_staff')}</th>
				              <th>{t('content.modal_history.register_date')}</th>
				              <th>{t('content.modal_history.status')}</th>
				              <th>{t('content.modal_history.reason')}</th>
				              <th>{t('content.modal_history.release_date')}</th>
				              <th width={103}>

				              </th>
				            </tr>
				          </thead>
				          <tbody>
				        	{this.state.history.map( (item, index) => (
              					<tr key={index}>
					                <td>{item.name}</td>
					                <td><Moment format="DD/MM/YYYY">{item.timeastamp_date}</Moment></td>
					                <td>{this.getStatus(item.status)}</td>
					                <td>{item.rejection_description}</td>
					                <td>
					                	{item.release_date !== null?
					                	<Moment format="DD/MM/YYYY">{item.release_date}</Moment>:<div></div>
					                	}
					               	</td>
					                <td>
					                	<button onClick={(e)=>this.openPDF(item.id)} style={{border:"0px"}}>
					                		<SvgIcon size={23} icon={filePdf} />
					                	</button>
					                </td>
					        	</tr>
				            ))}
				          </tbody>
				        </Table>
				    </div>}
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalHistorico) 